module.exports = __webpack_public_path__ + "static/media/theme_2.9f459a7e.jpg";